"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colorAppBar = "#000000";
const colorOnAppBar = "#FFFFFF";
const colorPrimary = "#000000";
const colorPrimaryDarker = "#000000";
const colorPrimaryLighter = "#cccccc";
const colorOnPrimary = "#FFFFFF";
const colorSecondary = "#B4A58B";
const colorOnSecondary = "#FFFFFF";
const colorTiles = ["#B4A58B", "#B4A58B", "#B4A58B"];
exports.default = {
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
